
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.146.146a.5.5 0 01.708 0l8 8a.5.5 0 11-.708.708l-8-8a.5.5 0 010-.708z","fill":"#333"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.854.146a.5.5 0 010 .708l-8 8a.5.5 0 11-.708-.708l8-8a.5.5 0 01.708 0z","fill":"#333"}})])
          )
        }
      }
    